const apiKey = "mqh5fqmz6m1tp3tp627rsp4ilfsrcp2c";
const defaultAmount = 100;
const sign = "wejelly";

export { defaultAmount, apiKey, sign};
